import React from 'react';

import ChartWithDetails from './ChartWithDetails';

const StakeHolderCharts: React.FC<{
  data: any;
  subData: any[];
  label: string;
}> = ({data, subData, label}) => {
  return (
    <>
      <ChartWithDetails
        // chartType="progress"
        // dataInMainData={true}
        mainData={data}
        labelType="percent"
        noBackground={true}
        subData={subData}
        mainLabel={label}
      />
    </>
  );
};

export default StakeHolderCharts;
